module.exports = __webpack_public_path__ + "static/media/Cooked_Green_Cap.06ba966f.webp";